/**
 * Auto-generated by generate-role-defaults.ts – DO NOT EDIT MANUALLY.
 * Generated on: 2026-07-02T10:11:24.664Z
 *
 * This file contains default role selections for all taxonomies:
 * - Default taxonomy
 * - All RICS K10 taxonomies
 * - All RICS K50 taxonomies
 */

export type RoleDefaultSelection = {
  id: string;
  name: string;
  levelId: 'role_k150';
};

/** Role taxonomy version these defaults were generated against. */
export const GENERATED_ROLE_DEFAULTS_VERSION = '3.2.0';

// Default // Default
export const GENERATED_DEFAULT_CUSTOM_ROLE_DEFAULT: RoleDefaultSelection[] = [
  {
    id: '2_117',
    name: 'Research Professional',
    levelId: 'role_k150',
  },
  {
    id: '4_53',
    name: 'Finance',
    levelId: 'role_k150',
  },
  {
    id: '7_68',
    name: 'Industry Software Engineer',
    levelId: 'role_k150',
  },
  {
    id: '10_63',
    name: 'HR Specialist',
    levelId: 'role_k150',
  },
  {
    id: '11_127',
    name: 'Salesperson',
    levelId: 'role_k150',
  },
];

// K50: rics_k50_1 // rics_k50_1
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_1: RoleDefaultSelection[] =
  [
    {
      id: '2_46',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '2_55',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '3_30',
      name: 'Developer',
      levelId: 'role_k150',
    },
    {
      id: '4_121',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
    {
      id: '11_125',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_2 // rics_k50_2
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_2: RoleDefaultSelection[] =
  [
    {
      id: '3_57',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '3_66',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '5_131',
      name: 'Software Development',
      levelId: 'role_k150',
    },
    {
      id: '9_118',
      name: 'Research Staff',
      levelId: 'role_k150',
    },
    {
      id: '10_127',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_3 // rics_k50_3
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_3: RoleDefaultSelection[] =
  [
    {
      id: '2_51',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '2_60',
      name: 'HR Professional',
      levelId: 'role_k150',
    },
    {
      id: '8_103',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
    {
      id: '8_132',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '10_86',
      name: 'Outside Sales',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_4 // rics_k50_4
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_4: RoleDefaultSelection[] =
  [
    {
      id: '2_71',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '6_123',
      name: 'Research Scholar',
      levelId: 'role_k150',
    },
    {
      id: '7_64',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '8_132',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
    {
      id: '11_128',
      name: 'Sales Professional',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_5 // rics_k50_5
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_5: RoleDefaultSelection[] =
  [
    {
      id: '1_115',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
    {
      id: '4_56',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_131',
      name: 'Software Professional',
      levelId: 'role_k150',
    },
    {
      id: '9_60',
      name: 'HR Management',
      levelId: 'role_k150',
    },
    {
      id: '10_132',
      name: 'Specialty Sales',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_6 // rics_k50_6
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_6: RoleDefaultSelection[] =
  [
    {
      id: '3_44',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_107',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '8_49',
      name: 'HR Management',
      levelId: 'role_k150',
    },
    {
      id: '9_117',
      name: 'Sales Executive',
      levelId: 'role_k150',
    },
    {
      id: '11_123',
      name: 'Software Professional',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_7 // rics_k50_7
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_7: RoleDefaultSelection[] =
  [
    {
      id: '1_43',
      name: 'Direct Sales',
      levelId: 'role_k150',
    },
    {
      id: '4_49',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '9_121',
      name: 'Research Personnel',
      levelId: 'role_k150',
    },
    {
      id: '10_129',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
    {
      id: '11_62',
      name: 'Human Resources',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_8 // rics_k50_8
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_8: RoleDefaultSelection[] =
  [
    {
      id: '1_45',
      name: 'Developer',
      levelId: 'role_k150',
    },
    {
      id: '4_54',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_62',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '9_100',
      name: 'Program Coordinator',
      levelId: 'role_k150',
    },
    {
      id: '11_113',
      name: 'Retail Salesperson',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_9 // rics_k50_9
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_9: RoleDefaultSelection[] =
  [
    {
      id: '1_118',
      name: 'Research and Analysis',
      levelId: 'role_k150',
    },
    {
      id: '4_53',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '4_67',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '9_126',
      name: 'Sales Executive',
      levelId: 'role_k150',
    },
    {
      id: '10_22',
      name: 'Backend Engineer',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_10 // rics_k50_10
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_10: RoleDefaultSelection[] =
  [
    {
      id: '1_57',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '4_114',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '6_67',
      name: 'HR Professional',
      levelId: 'role_k150',
    },
    {
      id: '6_109',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
    {
      id: '8_118',
      name: 'Software Specialist',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_11 // rics_k50_11
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_11: RoleDefaultSelection[] =
  [
    {
      id: '1_58',
      name: 'HR Management',
      levelId: 'role_k150',
    },
    {
      id: '1_105',
      name: 'Research and Development',
      levelId: 'role_k150',
    },
    {
      id: '3_53',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '8_119',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
    {
      id: '10_21',
      name: 'Coder',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_12 // rics_k50_12
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_12: RoleDefaultSelection[] =
  [
    {
      id: '2_58',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '2_126',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
    {
      id: '8_135',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '10_118',
      name: 'Research Fellows',
      levelId: 'role_k150',
    },
    {
      id: '11_69',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_13 // rics_k50_13
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_13: RoleDefaultSelection[] =
  [
    {
      id: '1_71',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '3_125',
      name: 'Research Staff',
      levelId: 'role_k150',
    },
    {
      id: '5_65',
      name: 'Financial Management',
      levelId: 'role_k150',
    },
    {
      id: '8_131',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
    {
      id: '10_137',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_14 // rics_k50_14
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_14: RoleDefaultSelection[] =
  [
    {
      id: '1_51',
      name: 'Finance Director',
      levelId: 'role_k150',
    },
    {
      id: '3_109',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '6_95',
      name: 'People Manager',
      levelId: 'role_k150',
    },
    {
      id: '9_12',
      name: 'Business Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '10_127',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_15 // rics_k50_15
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_15: RoleDefaultSelection[] =
  [
    {
      id: '1_116',
      name: 'Research Support Specialist',
      levelId: 'role_k150',
    },
    {
      id: '2_45',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '2_54',
      name: 'HR Professional',
      levelId: 'role_k150',
    },
    {
      id: '2_120',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '6_129',
      name: 'Software Engineering Specialists',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_16 // rics_k50_16
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_16: RoleDefaultSelection[] =
  [
    {
      id: '1_42',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '3_39',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '8_112',
      name: 'Sales Executive',
      levelId: 'role_k150',
    },
    {
      id: '9_120',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
    {
      id: '10_105',
      name: 'Researcher',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_17 // rics_k50_17
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_17: RoleDefaultSelection[] =
  [
    {
      id: '1_46',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '9_54',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '9_116',
      name: 'Researcher',
      levelId: 'role_k150',
    },
    {
      id: '9_133',
      name: 'Software Professional',
      levelId: 'role_k150',
    },
    {
      id: '10_124',
      name: 'Sales Associate',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_18 // rics_k50_18
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_18: RoleDefaultSelection[] =
  [
    {
      id: '1_61',
      name: 'HR Professional',
      levelId: 'role_k150',
    },
    {
      id: '5_54',
      name: 'Finance Business Partner',
      levelId: 'role_k150',
    },
    {
      id: '9_121',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '10_129',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
    {
      id: '11_17',
      name: 'Cloud Engineer',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_19 // rics_k50_19
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_19: RoleDefaultSelection[] =
  [
    {
      id: '1_66',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '3_129',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '4_61',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '8_116',
      name: 'Research Specialist',
      levelId: 'role_k150',
    },
    {
      id: '9_122',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_20 // rics_k50_20
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_20: RoleDefaultSelection[] =
  [
    {
      id: '2_54',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '3_62',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '5_40',
      name: 'Domain Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '7_51',
      name: 'Field Sales',
      levelId: 'role_k150',
    },
    {
      id: '10_107',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_21 // rics_k50_21
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_21: RoleDefaultSelection[] =
  [
    {
      id: '3_122',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
    {
      id: '5_65',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '6_135',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
    {
      id: '9_105',
      name: 'People Strategy',
      levelId: 'role_k150',
    },
    {
      id: '11_129',
      name: 'Sales Agent',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_22 // rics_k50_22
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_22: RoleDefaultSelection[] =
  [
    {
      id: '4_73',
      name: 'Human Resources',
      levelId: 'role_k150',
    },
    {
      id: '7_92',
      name: 'Mobile Engineer',
      levelId: 'role_k150',
    },
    {
      id: '7_116',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '10_51',
      name: 'Financial Planning Analyst',
      levelId: 'role_k150',
    },
    {
      id: '10_126',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_23 // rics_k50_23
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_23: RoleDefaultSelection[] =
  [
    {
      id: '1_56',
      name: 'HR Management',
      levelId: 'role_k150',
    },
    {
      id: '2_126',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '3_110',
      name: 'Research Specialist',
      levelId: 'role_k150',
    },
    {
      id: '5_42',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '9_118',
      name: 'Sales Consultant',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_24 // rics_k50_24
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_24: RoleDefaultSelection[] =
  [
    {
      id: '1_52',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '4_139',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '6_68',
      name: 'HR Management',
      levelId: 'role_k150',
    },
    {
      id: '7_113',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
    {
      id: '10_124',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_25 // rics_k50_25
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_25: RoleDefaultSelection[] =
  [
    {
      id: '1_127',
      name: 'Research Associate',
      levelId: 'role_k150',
    },
    {
      id: '2_54',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '3_136',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
    {
      id: '4_58',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '7_45',
      name: 'Domain Software Engineer',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_26 // rics_k50_26
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_26: RoleDefaultSelection[] =
  [
    {
      id: '1_68',
      name: 'HR Specialist',
      levelId: 'role_k150',
    },
    {
      id: '1_126',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '5_52',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_137',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
    {
      id: '8_103',
      name: 'Professional Staff',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_27 // rics_k50_27
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_27: RoleDefaultSelection[] =
  [
    {
      id: '2_48',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '3_101',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
    {
      id: '4_55',
      name: 'HR Management',
      levelId: 'role_k150',
    },
    {
      id: '10_111',
      name: 'Sales Professional',
      levelId: 'role_k150',
    },
    {
      id: '11_78',
      name: 'Mobile Developer',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_28 // rics_k50_28
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_28: RoleDefaultSelection[] =
  [
    {
      id: '3_49',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '3_123',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '8_92',
      name: 'People Operations',
      levelId: 'role_k150',
    },
    {
      id: '11_119',
      name: 'Research Specialist',
      levelId: 'role_k150',
    },
    {
      id: '11_131',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_29 // rics_k50_29
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_29: RoleDefaultSelection[] =
  [
    {
      id: '2_116',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '4_55',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_61',
      name: 'HR Director',
      levelId: 'role_k150',
    },
    {
      id: '8_123',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
    {
      id: '11_110',
      name: 'Researcher',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_30 // rics_k50_30
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_30: RoleDefaultSelection[] =
  [
    {
      id: '2_45',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '7_56',
      name: 'Human Resources Manager',
      levelId: 'role_k150',
    },
    {
      id: '8_106',
      name: 'R&D Professional',
      levelId: 'role_k150',
    },
    {
      id: '9_117',
      name: 'Sales Consultant',
      levelId: 'role_k150',
    },
    {
      id: '10_123',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_31 // rics_k50_31
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_31: RoleDefaultSelection[] =
  [
    {
      id: '1_57',
      name: 'HR Leadership',
      levelId: 'role_k150',
    },
    {
      id: '3_51',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '4_100',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '9_109',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '10_120',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_32 // rics_k50_32
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_32: RoleDefaultSelection[] =
  [
    {
      id: '1_54',
      name: 'Finance',
      levelId: 'role_k150',
    },
    {
      id: '1_61',
      name: 'HR Management',
      levelId: 'role_k150',
    },
    {
      id: '8_114',
      name: 'Sales Development Representative',
      levelId: 'role_k150',
    },
    {
      id: '9_111',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
    {
      id: '10_122',
      name: 'Software Professional',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_33 // rics_k50_33
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_33: RoleDefaultSelection[] =
  [
    {
      id: '4_47',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_56',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '6_139',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
    {
      id: '9_136',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '11_129',
      name: 'Research Associate',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_34 // rics_k50_34
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_34: RoleDefaultSelection[] =
  [
    {
      id: '2_47',
      name: 'Finance Professional',
      levelId: 'role_k150',
    },
    {
      id: '3_123',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '7_106',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '9_115',
      name: 'Sales Consultant',
      levelId: 'role_k150',
    },
    {
      id: '10_58',
      name: 'HR Professional',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_35 // rics_k50_35
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_35: RoleDefaultSelection[] =
  [
    {
      id: '1_128',
      name: 'Sales Manager',
      levelId: 'role_k150',
    },
    {
      id: '2_65',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '3_72',
      name: 'HR Management',
      levelId: 'role_k150',
    },
    {
      id: '7_54',
      name: 'Domain Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '10_123',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_36 // rics_k50_36
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_36: RoleDefaultSelection[] =
  [
    {
      id: '1_45',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '3_132',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
    {
      id: '4_120',
      name: 'Research Assistant',
      levelId: 'role_k150',
    },
    {
      id: '5_53',
      name: 'HR Professional',
      levelId: 'role_k150',
    },
    {
      id: '7_136',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_37 // rics_k50_37
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_37: RoleDefaultSelection[] =
  [
    {
      id: '2_49',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '2_58',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '8_116',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
    {
      id: '9_124',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '10_64',
      name: 'Industry Software Engineer',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_38 // rics_k50_38
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_38: RoleDefaultSelection[] =
  [
    {
      id: '2_117',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
    {
      id: '4_53',
      name: 'Finance',
      levelId: 'role_k150',
    },
    {
      id: '7_68',
      name: 'Industry Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '10_63',
      name: 'HR Specialist',
      levelId: 'role_k150',
    },
    {
      id: '11_127',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_39 // rics_k50_39
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_39: RoleDefaultSelection[] =
  [
    {
      id: '1_131',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '2_50',
      name: 'HR Management',
      levelId: 'role_k150',
    },
    {
      id: '3_42',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '9_116',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
    {
      id: '10_123',
      name: 'Sales Professional',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_40 // rics_k50_40
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_40: RoleDefaultSelection[] =
  [
    {
      id: '3_46',
      name: 'HR Management',
      levelId: 'role_k150',
    },
    {
      id: '6_40',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '9_120',
      name: 'Research Associate',
      levelId: 'role_k150',
    },
    {
      id: '10_36',
      name: 'Field Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '11_135',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_41 // rics_k50_41
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_41: RoleDefaultSelection[] =
  [
    {
      id: '6_56',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '7_109',
      name: 'Research Support Specialist',
      levelId: 'role_k150',
    },
    {
      id: '8_116',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
    {
      id: '9_62',
      name: 'HR Partner',
      levelId: 'role_k150',
    },
    {
      id: '10_124',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_42 // rics_k50_42
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_42: RoleDefaultSelection[] =
  [
    {
      id: '2_125',
      name: 'Sales',
      levelId: 'role_k150',
    },
    {
      id: '4_53',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_133',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
    {
      id: '10_141',
      name: 'Talent Development',
      levelId: 'role_k150',
    },
    {
      id: '11_117',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_43 // rics_k50_43
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_43: RoleDefaultSelection[] =
  [
    {
      id: '1_72',
      name: 'Human Resources',
      levelId: 'role_k150',
    },
    {
      id: '2_128',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '4_58',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '6_5',
      name: 'App Developer',
      levelId: 'role_k150',
    },
    {
      id: '8_132',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_44 // rics_k50_44
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_44: RoleDefaultSelection[] =
  [
    {
      id: '1_57',
      name: 'Human Resources',
      levelId: 'role_k150',
    },
    {
      id: '3_43',
      name: 'Finance Professional',
      levelId: 'role_k150',
    },
    {
      id: '4_131',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '8_113',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
    {
      id: '10_124',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_45 // rics_k50_45
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_45: RoleDefaultSelection[] =
  [
    {
      id: '2_75',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '2_140',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '4_68',
      name: 'Financial Planning',
      levelId: 'role_k150',
    },
    {
      id: '4_129',
      name: 'Research',
      levelId: 'role_k150',
    },
    {
      id: '11_134',
      name: 'Sales Consultant',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_46 // rics_k50_46
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_46: RoleDefaultSelection[] =
  [
    {
      id: '1_130',
      name: 'Research Support Specialist',
      levelId: 'role_k150',
    },
    {
      id: '2_60',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '3_66',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '3_132',
      name: 'Retail Sales',
      levelId: 'role_k150',
    },
    {
      id: '10_111',
      name: 'Programmer',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_47 // rics_k50_47
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_47: RoleDefaultSelection[] =
  [
    {
      id: '2_49',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '4_62',
      name: 'HR Partner',
      levelId: 'role_k150',
    },
    {
      id: '4_104',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '5_133',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '10_120',
      name: 'Sales Consultant',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_48 // rics_k50_48
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_48: RoleDefaultSelection[] =
  [
    {
      id: '1_23',
      name: 'Corporate Sales',
      levelId: 'role_k150',
    },
    {
      id: '2_108',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
    {
      id: '9_58',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '10_48',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '10_126',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_49 // rics_k50_49
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_49: RoleDefaultSelection[] =
  [
    {
      id: '4_59',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '8_64',
      name: 'HR Management',
      levelId: 'role_k150',
    },
    {
      id: '10_121',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
    {
      id: '11_108',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '11_124',
      name: 'Software Professional',
      levelId: 'role_k150',
    },
  ];

// K50: rics_k50_50 // rics_k50_50
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_50: RoleDefaultSelection[] =
  [
    {
      id: '2_88',
      name: 'People Manager',
      levelId: 'role_k150',
    },
    {
      id: '4_49',
      name: 'Financial Planning Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_132',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '6_111',
      name: 'Research',
      levelId: 'role_k150',
    },
    {
      id: '10_44',
      name: 'Field Sales',
      levelId: 'role_k150',
    },
  ];

// K10: rics_k10_1 // rics_k10_1
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_1: RoleDefaultSelection[] =
  [
    {
      id: '1_48',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '6_58',
      name: 'HR Business Partner',
      levelId: 'role_k150',
    },
    {
      id: '6_138',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
    {
      id: '8_127',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
    {
      id: '11_108',
      name: 'Research Specialist',
      levelId: 'role_k150',
    },
  ];

// K10: rics_k10_2 // rics_k10_2
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_2: RoleDefaultSelection[] =
  [
    {
      id: '1_52',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '8_62',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '8_121',
      name: 'Researcher',
      levelId: 'role_k150',
    },
    {
      id: '9_42',
      name: 'Direct Sales',
      levelId: 'role_k150',
    },
    {
      id: '11_136',
      name: 'Specialized Software Engineer',
      levelId: 'role_k150',
    },
  ];

// K10: rics_k10_3 // rics_k10_3
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_3: RoleDefaultSelection[] =
  [
    {
      id: '2_51',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '3_136',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '5_59',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '7_122',
      name: 'Research Services',
      levelId: 'role_k150',
    },
    {
      id: '8_131',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
  ];

// K10: rics_k10_4 // rics_k10_4
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_4: RoleDefaultSelection[] =
  [
    {
      id: '3_70',
      name: 'Financial Planning Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_81',
      name: 'HR Management',
      levelId: 'role_k150',
    },
    {
      id: '5_123',
      name: 'Research',
      levelId: 'role_k150',
    },
    {
      id: '10_128',
      name: 'Sales Consultant',
      levelId: 'role_k150',
    },
    {
      id: '11_137',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
  ];

// K10: rics_k10_5 // rics_k10_5
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_5: RoleDefaultSelection[] =
  [
    {
      id: '3_52',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '3_56',
      name: 'HR Leadership',
      levelId: 'role_k150',
    },
    {
      id: '9_124',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
    {
      id: '10_126',
      name: 'Retail Salesperson',
      levelId: 'role_k150',
    },
    {
      id: '11_137',
      name: 'Software Development',
      levelId: 'role_k150',
    },
  ];

// K10: rics_k10_6 // rics_k10_6
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_6: RoleDefaultSelection[] =
  [
    {
      id: '3_54',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '8_121',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
    {
      id: '9_126',
      name: 'Sales Consultant',
      levelId: 'role_k150',
    },
    {
      id: '10_133',
      name: 'Software Professional',
      levelId: 'role_k150',
    },
    {
      id: '11_62',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
  ];

// K10: rics_k10_7 // rics_k10_7
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_7: RoleDefaultSelection[] =
  [
    {
      id: '4_47',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_56',
      name: 'HR Manager',
      levelId: 'role_k150',
    },
    {
      id: '6_139',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
    {
      id: '9_136',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '11_129',
      name: 'Research Associate',
      levelId: 'role_k150',
    },
  ];

// K10: rics_k10_8 // rics_k10_8
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_8: RoleDefaultSelection[] =
  [
    {
      id: '1_51',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '4_59',
      name: 'HR Executive',
      levelId: 'role_k150',
    },
    {
      id: '9_114',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '10_123',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
    {
      id: '11_104',
      name: 'Research Professional',
      levelId: 'role_k150',
    },
  ];

// K10: rics_k10_9 // rics_k10_9
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_9: RoleDefaultSelection[] =
  [
    {
      id: '1_119',
      name: 'Research Support Specialist',
      levelId: 'role_k150',
    },
    {
      id: '2_54',
      name: 'Finance Control',
      levelId: 'role_k150',
    },
    {
      id: '3_123',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '6_69',
      name: 'Human Resources',
      levelId: 'role_k150',
    },
    {
      id: '11_130',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ];

// K10: rics_k10_10 // rics_k10_10
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_10: RoleDefaultSelection[] =
  [
    {
      id: '4_59',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '8_64',
      name: 'HR Management',
      levelId: 'role_k150',
    },
    {
      id: '10_121',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
    {
      id: '11_108',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '11_124',
      name: 'Software Professional',
      levelId: 'role_k150',
    },
  ];

// Custom: ONET // ONET
export const GENERATED_DEFAULT_CUSTOM_ROLE_CUSTOM_61: RoleDefaultSelection[] = [
  {
    id: '1_3',
    name: 'Operations Specialties Managers',
    levelId: 'role_k150',
  },
  {
    id: '3_7',
    name: 'Computer Occupations',
    levelId: 'role_k150',
  },
  {
    id: '5_15',
    name: 'Life, Physical, and Social Science Technicians',
    levelId: 'role_k150',
  },
  {
    id: '16_58',
    name: 'Sales Representatives, Wholesale and Manufacturing',
    levelId: 'role_k150',
  },
];

// Custom: ESCO // ESCO
export const GENERATED_DEFAULT_CUSTOM_ROLE_CUSTOM_62: RoleDefaultSelection[] = [
  {
    id: '2_5',
    name: 'Administrative and Commercial Managers',
    levelId: 'role_k150',
  },
  {
    id: '3_10',
    name: 'Teaching Professionals',
    levelId: 'role_k150',
  },
  {
    id: '3_12',
    name: 'Information and Communications Technology Professionals',
    levelId: 'role_k150',
  },
  {
    id: '4_16',
    name: 'Business and Administration Associate Professionals',
    levelId: 'role_k150',
  },
];

// Custom: LIGHTCAST // LIGHTCAST
export const GENERATED_DEFAULT_CUSTOM_ROLE_CUSTOM_63: RoleDefaultSelection[] = [
  {
    id: '10_68',
    name: 'Financial Analysis',
    levelId: 'role_k150',
  },
  {
    id: '13_111',
    name: 'Human Resources Managers',
    levelId: 'role_k150',
  },
  {
    id: '14_118',
    name: 'Network and Systems Engineering',
    levelId: 'role_k150',
  },
  {
    id: '23_164',
    name: 'Technical Sales',
    levelId: 'role_k150',
  },
  {
    id: '24_168',
    name: 'General Research',
    levelId: 'role_k150',
  },
];

// Custom: NOC // NOC
export const GENERATED_DEFAULT_CUSTOM_ROLE_CUSTOM_64: RoleDefaultSelection[] = [
  {
    id: '1_1',
    name: 'Specialized middle management occupations in administrative services, financial and business services and communication (except broadcasting)',
    levelId: 'role_k150',
  },
  {
    id: '1_5',
    name: 'Specialized administrative occupations',
    levelId: 'role_k150',
  },
  {
    id: '2_15',
    name: 'Professional occupations in applied sciences (except engineering)',
    levelId: 'role_k150',
  },
  {
    id: '6_52',
    name: 'Retail salespersons and non-technical wholesale trade sales and account representatives',
    levelId: 'role_k150',
  },
];
